import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferListProvidersPathParameters } from 'api/actions/price-offer-list-providers/price-offer-list-providers-path-parameters';
import { PriceOfferListProvidersResponse } from 'api/actions/price-offer-list-providers/price-offer-list-providers-response';

type PriceOfferListProvidersQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferListProviders action.
 */
export const priceOfferListProvidersActionPath = new SweetPath<keyof PriceOfferListProvidersPathParameters>(
  '/api/price-offer/list-providers',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferListProviders actions.
 */
export default function createPriceOfferListProvidersAction(axios: AxiosInstance) {
  return function priceOfferListProvidersAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: PriceOfferListProvidersQueryParameters } = {}) {
    const path = priceOfferListProvidersActionPath.original;

    return axios.request<PriceOfferListProvidersResponse, PriceOfferListProvidersResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
